import { Injectable, inject } from '@angular/core';
import { first, map, mergeMap } from 'rxjs';
import { EffectsBase } from 'clicklease-ui-elements';
import { Contract } from '../../interfaces';
import { RoseService } from '../../services';
import { 
    LoadContractsAction,
    SetContractsAction,
    getRoseKeySelector
} from '../../ngrx';

@Injectable()
export class ContractsEffectsService extends EffectsBase {
    readonly #roseService = inject(RoseService);
    readonly #roseKey = this.store.selectSignal(getRoseKeySelector);

    public readonly loadContracts = this.createEffect(() =>
        this.actions.pipe(
            this.ofType(LoadContractsAction),
            mergeMap(() => this.doLoadContractsEffect())
        )
    );

    private doLoadContractsEffect() {
        return this.#roseService.getLeases(this.#roseKey()).pipe(
            map((list: Contract[]) => SetContractsAction({ list })),
            first(),
        );
    }

}